import type { Job } from '@/schema'

const PROVIDERS: Record<string, string> = { openrouter: 'OpenRouter', agy: 'Antigravity', cli: 'Claude CLI', gemini: 'Gemini', mock: 'Mock' }

/** Actual adapter calls, never the current Settings (which may have changed). */
export function JobModelLabel({ job }: { job: Job }) {
  const data = job.progress.data
  if (!data?.ai_model) return null
  const provider = PROVIDERS[data.ai_provider ?? ''] ?? data.ai_provider
  const history = data.ai_models?.map((entry) => `${PROVIDERS[entry.provider] ?? entry.provider} · ${entry.model}`).join('\n')
  return (
    <p className="break-all text-xs text-ink-2" title={`Most recent AI call${history ? `; models used:\n${history}` : ''}`}>
      Model: {provider ? `${provider} · ` : ''}{data.ai_model}
    </p>
  )
}
